module.exports = __webpack_public_path__ + "img/ss_blue-00.8a70837a.jpg";